import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { BillingPipe } from './billing.pipe';
import { LicenseTypePipe } from './license-type.pipe';
import { PricePrepaymentPipe } from './price-prepayment.pipe';
import { PricePipe } from './price.pipe';

@NgModule({
  imports: [LicenseTypePipe, PricePipe, BillingPipe, PricePrepaymentPipe],
  exports: [PricePipe, BillingPipe, PricePrepaymentPipe, LicenseTypePipe],
  providers: [PricePipe, BillingPipe, PricePrepaymentPipe, DecimalPipe]
})
export class LicensesPipesModule {}
